import { createSelector } from 'reselect'

const getBattle = state => state.battle

const getStoryFromStage = createSelector(
    getBattle,
    (battle) => {
        if (!battle || !battle.stage) { return [] }

        const { stage: { location }, currentStep, currentPhase } = battle
        if (currentPhase === -1) { return { story: [] } }

        const { story } = location[currentStep][currentPhase]
        return story || []
    }
)

export default getStoryFromStage
